export const data= [
  {
    "Title": "Aces High",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 55,
    "": "Gilligans"
  },
  {
    "Title": "Crime SuspenStories",
    "Issue #": 15,
    "Condition": "CGC 5.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 450,
    "": "TTreasures"
  },
  {
    "Title": "Crime SuspenStories",
    "Issue #": 19,
    "Condition": "CGC 4.5",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 750,
    "": "Trade Keith"
  },
  {
    "Title": "Crime SuspenStories",
    "Issue #": 19,
    "Condition": "VG",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 500,
    "": "Tim"
  },
  {
    "Title": "Crime SuspenStories",
    "Issue #": 21,
    "Condition": "FN+",
    "Website Notes": "Classic Cover",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 600,
    "": "Darnell"
  },
  {
    "Title": "Crime SuspenStories",
    "Issue #": 27,
    "Condition": "FN",
    "Website Notes": "Last Issue Low Dist",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Beyond"
  },
  {
    "Title": "Frontline Combat",
    "Issue #": 4,
    "Condition": "VG",
    "Website Notes": "Used in SOTI",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "Ogden"
  },
  {
    "Title": "Frontline Combat",
    "Issue #": 7,
    "Condition": "VG/F",
    "Website Notes": "Iwo Jima",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": ""
  },
  {
    "Title": "Frontline Combat",
    "Issue #": 14,
    "Condition": "GD+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": "",
    "": ""
  },
  {
    "Title": "Humbug",
    "Issue #": 2,
    "Condition": "GD  ",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Rich G"
  },
  {
    "Title": "Humbug",
    "Issue #": 3,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Rich G"
  },
  {
    "Title": "Impact",
    "Issue #": 2,
    "Condition": "G//VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Joe"
  },
  {
    "Title": "Incredible Science Fiction",
    "Issue #": 32,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Joe"
  },
  {
    "Title": "Mad",
    "Issue #": 1,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 575,
    "": "Gilligans"
  },
  {
    "Title": "Mad",
    "Issue #": 2,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 350,
    "": "Matt"
  },
  {
    "Title": "Mad",
    "Issue #": 6,
    "Condition": "CGC 6.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 230,
    "": "Comiclink"
  },
  {
    "Title": "Mad",
    "Issue #": 7,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Matt"
  },
  {
    "Title": "Mad",
    "Issue #": 8,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Matt"
  },
  {
    "Title": "Mad",
    "Issue #": 9,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Matt"
  },
  {
    "Title": "Mad",
    "Issue #": 10,
    "Condition": "VG+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Matt"
  },
  {
    "Title": "Mad",
    "Issue #": 11,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Matt"
  },
  {
    "Title": "Mad",
    "Issue #": 12,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 120,
    "": "Beyond"
  },
  {
    "Title": "Mad",
    "Issue #": 12,
    "Condition": "FN-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Matt"
  },
  {
    "Title": "Mad",
    "Issue #": 13,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Matt"
  },
  {
    "Title": "Mad",
    "Issue #": 14,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Matt"
  },
  {
    "Title": "Mad",
    "Issue #": 15,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "Beyond"
  },
  {
    "Title": "Mad",
    "Issue #": 15,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Matt"
  },
  {
    "Title": "Mad",
    "Issue #": 16,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 80,
    "": "Beyond"
  },
  {
    "Title": "Mad",
    "Issue #": 16,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Matt"
  },
  {
    "Title": "Mad",
    "Issue #": 17,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "2 avail",
    "Cost Basis": 65,
    "": "Beyond"
  },
  {
    "Title": "Mad",
    "Issue #": 18,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 70,
    "": "Beyond"
  },
  {
    "Title": "Mad",
    "Issue #": 18,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Matt"
  },
  {
    "Title": "Mad",
    "Issue #": 19,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 160,
    "": "Beyond"
  },
  {
    "Title": "Mad",
    "Issue #": 19,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Matt"
  },
  {
    "Title": "Mad",
    "Issue #": 20,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Matt"
  },
  {
    "Title": "Mad",
    "Issue #": 20,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Bob Fox"
  },
  {
    "Title": "Mad",
    "Issue #": 21,
    "Condition": "VF-",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Beyond"
  },
  {
    "Title": "Mad",
    "Issue #": 21,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Matt"
  },
  {
    "Title": "Mad",
    "Issue #": 22,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Matt"
  },
  {
    "Title": "Mad",
    "Issue #": 23,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Beyond"
  },
  {
    "Title": "Mad",
    "Issue #": 23,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 50,
    "": "Matt"
  },
  {
    "Title": "Mad",
    "Issue #": 24,
    "Condition": "F/VF",
    "Website Notes": "1st Magazine Iss",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 300,
    "": "Matt"
  },
  {
    "Title": "Mad",
    "Issue #": 24,
    "Condition": "VG/F",
    "Website Notes": "1st Magazine Iss",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 75,
    "": "PBA"
  },
  {
    "Title": "Mad",
    "Issue #": 30,
    "Condition": "FN-",
    "Website Notes": "1st AE Neuman C",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Matt"
  },
  {
    "Title": "MD",
    "Issue #": 4,
    "Condition": "G/VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 10,
    "": "Rich G"
  },
  {
    "Title": "Moon Girl",
    "Issue #": 4,
    "Condition": "VG",
    "Website Notes": "Int Panel cut out ow VG",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Tim"
  },
  {
    "Title": "Panic",
    "Issue #": 2,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "TTreasures"
  },
  {
    "Title": "Panic",
    "Issue #": 3,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Rich G"
  },
  {
    "Title": "Panic",
    "Issue #": 6,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Rich G"
  },
  {
    "Title": "Panic",
    "Issue #": 9,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Rich G"
  },
  {
    "Title": "Panic",
    "Issue #": 10,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "GA",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Panic",
    "Issue #": 11,
    "Condition": "FN",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Rich G"
  },
  {
    "Title": "Panic",
    "Issue #": 12,
    "Condition": "FN+",
    "Website Notes": "",
    "Personal Notes (Not on website)": "GA",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Shock Illustrated",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "Magazine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "TBC"
  },
  {
    "Title": "ShockSuspenstories",
    "Issue #": 16,
    "Condition": "VG/F",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Beyond"
  },
  {
    "Title": "ShockSuspenstories",
    "Issue #": 16,
    "Condition": "CGC 4.0",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 225,
    "": "CConnect"
  },
  {
    "Title": "Tales of Terror",
    "Issue #": 1,
    "Condition": "VG/F",
    "Website Notes": "Magazine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "TBC"
  },
  {
    "Title": "Tales of Terror",
    "Issue #": 2,
    "Condition": "VG/F",
    "Website Notes": "Magazine",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "TBC"
  },
  {
    "Title": "Two-Fisted Tales",
    "Issue #": 27,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Gilligans"
  },
  {
    "Title": "Two-Fisted Tales",
    "Issue #": 28,
    "Condition": "FN-",
    "Website Notes": "Classic Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 35,
    "": "Vince"
  },
  {
    "Title": "Two-Fisted Tales",
    "Issue #": 28,
    "Condition": "VG/F",
    "Website Notes": "Classic Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "TTreasures"
  },
  {
    "Title": "Two-Fisted Tales",
    "Issue #": 28,
    "Condition": "VG",
    "Website Notes": "Classic Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": "Gilligans"
  },
  {
    "Title": "Two-Fisted Tales",
    "Issue #": 34,
    "Condition": "VG/F",
    "Website Notes": "Civil War",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 40,
    "": "Annandale"
  },
  {
    "Title": "Two-Fisted Tales",
    "Issue #": 34,
    "Condition": "VG",
    "Website Notes": "Civil War",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 65,
    "": "Dahlgren"
  },
  {
    "Title": "Two-Fisted Tales",
    "Issue #": 37,
    "Condition": "VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": ""
  },
  {
    "Title": "Two-Fisted Tales",
    "Issue #": 41,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 30,
    "": "Rich G"
  },
  {
    "Title": "Valor",
    "Issue #": 4,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Valor",
    "Issue #": 5,
    "Condition": "GD",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 15,
    "": ""
  },
  {
    "Title": "Vault of Horror",
    "Issue #": 15,
    "Condition": "FN",
    "Website Notes": "Classic Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 720,
    "": "Todd"
  },
  {
    "Title": "Vault of Horror",
    "Issue #": 27,
    "Condition": "VG",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 250,
    "": ""
  },
  {
    "Title": "Vault of Horror",
    "Issue #": 35,
    "Condition": "CGC 4.5",
    "Website Notes": "Classic Cvr",
    "Personal Notes (Not on website)": "B. Blue",
    "Cost Basis": 1325,
    "": "CConnect"
  },
  {
    "Title": "Vault of Horror",
    "Issue #": 36,
    "Condition": "F/VF",
    "Website Notes": "",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 400,
    "": ""
  },
  {
    "Title": "Weird Fantasy",
    "Issue #": 8,
    "Condition": "VG/F",
    "Website Notes": "C Touch",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "S. Ogden"
  },
  {
    "Title": "Weird Fantasy",
    "Issue #": 19,
    "Condition": "VG/F",
    "Website Notes": "Williamson Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Beyond"
  },
  {
    "Title": "Weird Fantasy",
    "Issue #": 19,
    "Condition": "GD",
    "Website Notes": "Williamson Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Jerry Hayes"
  },
  {
    "Title": "Weird Fantasy",
    "Issue #": 19,
    "Condition": "F/G",
    "Website Notes": "Williamson Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 25,
    "": "Beyond"
  },
  {
    "Title": "Weird Science  ",
    "Issue #": 15,
    "Condition": "GD",
    "Website Notes": "Williamson Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 200,
    "": "Gilligans"
  },
  {
    "Title": "Weird Science Fantasy",
    "Issue #": 25,
    "Condition": "VG",
    "Website Notes": "Williamson Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Jerry Hayes"
  },
  {
    "Title": "Weird Science Fantasy",
    "Issue #": 26,
    "Condition": "G/VG",
    "Website Notes": "Flying Saucer Story",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 45,
    "": "Clink"
  },
  {
    "Title": "Weird Science Fantasy",
    "Issue #": 28,
    "Condition": "VG",
    "Website Notes": "Williamson Art",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 100,
    "": "Gilligans"
  },
  {
    "Title": "Weird Science Fantasy",
    "Issue #": 29,
    "Condition": "VG",
    "Website Notes": "Classic Frazetta Cvr",
    "Personal Notes (Not on website)": "",
    "Cost Basis": 270,
    "": "Gilligans"
  }
];